import {HTMLAttributes} from 'react';
import {ListItemAvatar, ListItemText, ListItem} from '@mui/material';
import {TFunction} from 'i18next';
import NewConditionAvatar from './NewConditionAvatar';

export default function NewConditionItem({
  liProps,
  t
}: {
  t: TFunction;
  liProps?: HTMLAttributes<HTMLLIElement>;
}) {
  return (
    <ListItem data-testid="newPathologyOption" {...liProps}>
      <ListItemAvatar>
        <NewConditionAvatar />
      </ListItemAvatar>
      <ListItemText
        primary={t('shared/common:diagnosticReport.form.selectPathology.newPathology')}
      />
    </ListItem>
  );
}
